import { CurrentLang } from '../properties/Resources';

class ExternalLinkUtilsClass {
    public GetExternalMenu (externalMenu, tool) {
        if (externalMenu === null || tool === null) { return null; }
        for (const menuIt of externalMenu) {
            const text = menuIt.text;
            const clientTab = tool.clientTab;
            const alliaseTabName = this.GetAlliaseTabName(tool);
            const hasAlliaseTabName = alliaseTabName !== '';
            const tabMatch = text === clientTab;
            const aliasMatch = text === alliaseTabName;

            if ((hasAlliaseTabName && aliasMatch) || (!hasAlliaseTabName && tabMatch)) { return menuIt; }
        }
        return null;
    }

    public GetAlliaseTabName (tool): string {
        if (tool.aliases) {
            const aliases = tool.aliases;
            for (let j = 0; j < aliases.length; j++) {
                if (aliases[j].lang === CurrentLang) { return aliases[j].tabName; }
            }
        }
        return '';
    }
}

export const ExternalLinkUtils = new ExternalLinkUtilsClass();
